import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  color: white;
  width: 85%;
  padding: 1em 0;
  justify-content: space-between;
  font-size: 2em;

  a{
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover{
      cursor: pointer;
      color: #e4e4e4;
    }
  }

  img{
    width: 4em;
  }
`